import { ReactNode } from 'react';

import { PermissionString, Roles } from '@interfaces/users.interface';

import useUserPermissionGuard from '@hooks/useUserPermissionGuard';

interface UserRoleGuardProps {
  permission: PermissionString | null;
  relatedOnly?: boolean;
  excludeRoles?: Roles[];
  children: ReactNode;
}

export default function UserPermissionGuard({
  permission,
  relatedOnly,
  excludeRoles,
  children,
}: UserRoleGuardProps) {
  const hasPermission = useUserPermissionGuard(
    permission,
    relatedOnly,
    excludeRoles,
  );

  return hasPermission && children;
}
